import request from '@/utils/request'

export function save(data) {
  return request({
    url: '/admin/addEvents',
    method: 'post',
    data
  })
}

export function getUpcomingEvents() {
  return request({
   url: '/admin/getEventList/upcoming',
   method: 'get',
   })
}

export function getUninvitedUpcomingEvents(user_id) {
  return request({
   url: '/admin/getEventList/uninvited-upcoming?user_id='+user_id,
   method: 'get'
  })
}

export function getAliveEvents() {
  return request({
   url: '/admin/getEventList/alive',
   method: 'get',
   })
}

export function getEventDetails(event_id){
  return request({
    url: '/getEventById/'+event_id,
    method: 'get',
  })
}

export function downloadFile() {
  return request({
    url: '/admin/getSampleFileData',
    method: 'get',
    responseType: 'blob'
  })
}

export function downloadMom(data) {
  return request({
    url: '/admin/generate-mom-docx',
		method: 'post',
    responseType: 'blob',
		data
  })
}

export function downloadRecording(data) {
  return request({
    url: '/admin/downloadRecording',
    method: 'post',
    responseType: 'blob',
		data
  })
}

export function uploadFile(data) {
  return request({
    url: '/admin/users/getFileUsers',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}

export function changeEventStatus(data) {
  return request({
    url: '/admin/changeEventStatus/'+data.event_id+'/'+data.status,
    method: 'get',
  })
}

export function changeStreamingStatus(data) {
  return request({
    url: '/admin/changeStreamingStatus/'+data.event_id+'/'+data.status,
    method: 'get',
  })
}

export function changeRecordingStatus(data) {
  return request({
    url: '/admin/changeRecordingStatus/'+data.event_id+'/'+data.status,
    method: 'get',
  })
}

export function importUsers(data) {
  return request({
    url: '/admin/users/import',
    method: 'post',
    data
  })
}

export function changeEventVotingStatus(data) {
  return request({
    url: '/admin/changeEventVotingStatus/'+data.event_voting_id+'/'+data.status,
    method: 'get',
  })
}


export function getEventStatus(data) {
  return request({
    url: '/getEventStatus/'+data.event_id+'/'+data.user_id,
    method: 'get',
  })
}

export function getEventResult(data) {
  return request({
    url: '/getEventVotingResults/'+data,
    method: 'get',
  })
}

export function getPastEvents() {
  return request({
   url: '/admin/getEventList/past',
   method: 'get',
   })
}

export function getAllEvents() {
  return request({
    url: '/admin/getEventList/all',
    method: 'get',
  })
}

export function endVoting(data) {
  return request({
    url: '/admin/endVoting',
    method: 'post',
    data
  })
}

export function getEventId(data) {
  return request({
    url: '/getEventBySlug',
    method: 'post',
    data
  })
}


export function getVotingResult(data) {
  return request({
    url: '/getVotingResults/' + data,
    method: 'get'
  })
}

export function getDetailsFromUUID(data) {
  return request({
    url: '/getUserEventInfoByUuid/' + data,
    method: 'get'
  })
}

export function submitAttendance(data) {
  return request({
    url: '/submitAttendance',
    method: 'post',
    data
  })
}

export function getEventUsers(data) {
  return request({
    url: 'getInvitedUsersByEventId/'+data,
    method: 'get',
  })
}

export function getVotingTypes(data) {
  return request({
    url: 'admin/getTypes',
    method: 'get'
  })
}

export function deleteEvent(data) {
  return request({
    url: '/admin/deleteEvent/'+data,
    method: 'post'
  })
}

export function updateEvents(data) {
  return request({
    url: '/admin/updateEvents',
    method: 'post',
    data
  })
}

export function rsvpSendOtp(data) {
  return request({
    url: '/rsvpSendOtp',
    method: 'post',
    data
  })
}

export function rsvpVerifyOtp(data) {
  return request({
    url: '/rsvpVerifyOtp',
    method: 'post',
    data
  })
}

export function logErrors(data) {
  return request({
    url: '/log',
    method: 'post',
    data
  })
}

export function getOnlyEventDetails(data) {
  return request({
    url: '/getEventDetails/'+data,
    method: 'get'
  })
}

export function getEventRecordings(data) {
  return request({
    url: '/getEventRecordings/'+data,
    method: 'get'
  })
}

export function getQuorums(data) {
  return request({
    url: 'admin/getAllQuorumTypes/',
    method: 'get'
  })
}

export function resetEvent(data) {
  return request({
    url: '/admin/resetEvent/'+data,
    method: 'get'
  })
}

export function getEventNotifications(data) {
  return request({
    url: '/admin/getEventNotification/'+data.event_id+'/'+data.slug,
    method: 'get',
  })
}

export function updateEventNotifications(data) {
  return request({
    url: 'admin/updateEventNotification',
    method: 'post',
    data
  })
}

export function eventMarkAsSpeaker(event_id,data) {
  return request({
    url: 'eventMarkAsSpeaker/' + event_id,
    method: 'post',
    data
  })
}

export function eventMarkAsSpeakerFromUser(event_id,data) {
  return request({
    url: 'eventMarkAsSpeakerFromUser/' + event_id,
    method: 'post',
    data
  })
}

export function eventHandRaised(event_id,data) {
  return request({
    url: 'eventHandRaised/' + event_id,
    method: 'post',
    data
  })
}

export function eventStartSpeakerTime(event_id,data) {
  return request({
    url: 'eventStartSpeakerTime/' + event_id,
    method: 'post',
    data
  })
}


export function saveEventChat(data) {
  return request({
    url: 'saveChat',
    method: 'post',
    data
  })
}

export function getMessageList(data) {
  return request({
    url: 'getMessageList',
    method: 'post',
    data
  })
}

export function getChatList(data) {
  return request({
    url: 'getChatList',
    method: 'post',
    data
  })
}

export function updateMuteStatus(data) {
  return request({
    url: 'updateMuteStatus',
    method: 'post',
    data
  })
}

export function getEventVotingHistory(data) {
  return request({
    url: 'admin/getEventVotingHistory',
    method: 'post',
    data
  })
}

export function getSpeakerTimer(id) {
  return request({
    url: 'getSpeakerTimer/'+id,
    method: 'GET'
  })
}

export function toggleBlockUnmuteSpeaker(id, user_id) {
  return request({
    url: 'toggle-block-unmute-speaker/'+id,
    method: 'POST',
    data: {user_id: user_id}
  });
}

export function upcomingEventInviteUser(id, req) {
  return request({
    url: 'admin/user/'+id+'/invite-multiple-events',
    data: req,
    method: 'POST',
  });
}